import { createContext } from 'react'

export type BackHistoryRegister = (onBack: () => void | false) => () => void
export const BackHistoryContext = createContext<BackHistoryRegister>(null as any)
